export const escapePrintText = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));

// Reuse the actual displayed typography for the existing browser Print/PDF flow.
export function lessonReadingPrintStyles() {
  return [...document.styleSheets].flatMap(sheet => {
    try { return [...sheet.cssRules].filter(rule => /lesson-reading|lesson-section/.test(rule.cssText)).map(rule => rule.cssText); }
    catch { return []; } // External font stylesheets may disallow CSSOM reads.
  }).join('\n');
}